import React, { useEffect } from "react";
import useEntryCommentState from '../../stores/EntryCommentState'
import { useState, Downgraded, State } from "@hookstate/core";
import { DisplayComments } from "~/components/DisplayComments";
import { CommentDataProps } from "~/features/Dispatch/stores/DispatchCommentState";

const defaultCommentsState: readonly CommentDataProps[] = []

interface EntryDisplayCommentsProps {
  readonly commentIsCompressed: State<boolean>;
  readonly moveScrolltoComment?: boolean;
  readonly entryId: number | null;
}

export function EntryDisplayComments({ commentIsCompressed, moveScrolltoComment, entryId }: EntryDisplayCommentsProps) {
  const [syncSuccess, setSyncSuccess] = React.useState(true)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [syncError, setSyncError] = React.useState<string | null>(null)

  const { allCurrentComments, sortComment, syncPreviousComments } = useEntryCommentState();
  const commentList = useState(defaultCommentsState)
  const allCommentsValue = allCurrentComments().attach(Downgraded).value;
  const loading = useState(true)

  const populateComments = () => { 
    commentList.set(allCommentsValue ? allCommentsValue.map(element => element).sort(sortComment) : []);
  }

  const getCommentsFromEntryId = async () => {
    setSyncSuccess(true)
    setSyncError(null)

    if (!entryId) return;

    try {
      const success = await syncPreviousComments(entryId);

      if (!success) {
        setSyncSuccess(false)
        setSyncError('Erro ao sincronizar comentários.')
      } else if (commentList.get().length && commentList[0].entryId.get() && entryId != commentList[0].entryId.get()) {
        setSyncSuccess(false)
        setSyncError('Erro ao sincronizar comentários relacionados a ocorrência.')
      }
    } catch (error) {
      console.error('Erro ao buscar comentários:', error)
      setSyncSuccess(false)
      setSyncError(error instanceof Error ? error.message : 'Erro desconhecido')
    }
  }

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      loading.set(true)
      await getCommentsFromEntryId()
      if (isMounted) {
        loading.set(false)
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [entryId])

  useEffect(() => {
    populateComments();
  }, [allCommentsValue]);

  return (
    <DisplayComments
      isEdit={true}
      isDispatch={false}
      comments={commentList}
      commentIsCompressed={commentIsCompressed}
      moveScrolltoComment={moveScrolltoComment}
      loading={loading.get()}
      refresh={syncSuccess}
      refreshAction={getCommentsFromEntryId}
    />
  )
}
